var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c(
        "a",
        {
          staticClass:
            "btn btn-outline-white text-white btn-default waves-effect waves-light position-absolute m-05",
          attrs: { href: _vm.previous_page },
        },
        [
          _c("i", { staticClass: "feather icon-arrow-left" }),
          _vm._v(
            " " + _vm._s(_vm.__("event.form.buttons.back")) + "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "shadow" }, [
        _c("img", {
          staticClass: "card-img-top img-fluid",
          staticStyle: { "object-fit": "cover" },
          attrs: {
            src:
              _vm.event.event_image == null
                ? "/images/cover.jpg"
                : _vm.event.event_image.url,
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-body pt-1 pb-0" }, [
          _c("div", { staticClass: "mb-2" }, [
            _c("div", {}, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between",
                },
                [
                  _c("h1", {
                    staticClass: "font-large-1",
                    domProps: { textContent: _vm._s(_vm.event.title) },
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm.event.access === "Offline Event"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "mb-05 badge badge-pill bg-gradient-secondary d-block text-bold-700 font-small-2 ",
                          },
                          [
                            _c("i", { staticClass: "feather icon-user-plus" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.__("event.cards.offline")) +
                                "\n                                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.event.access === "Online Event"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "mb-05 badge badge-pill badge-success d-block text-bold-700 font-small-2 ",
                          },
                          [
                            _c("i", { staticClass: "feather icon-globe" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.__("event.cards.online")) +
                                "\n                                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.event.access === "Hybrid Event"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "mb-05 badge badge-pill badge-warning d-block text-bold-700 font-small-2 ",
                          },
                          [
                            _c("i", { staticClass: "feather icon-calendar" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.__("event.cards.hybrid")) +
                                "\n                                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    this.sold_out === true
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "mb-05 badge badge-pill badge-danger d-block font-small-2 text-bold-700",
                          },
                          [
                            _c("i", {
                              staticClass: "feather icon-alert-circle",
                            }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.__("event.sold_out")) +
                                "\n                                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.event.event_privacy === 1
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "mb-05 badge badge-pill  d-block font-small-2 text-bold-700",
                          },
                          [
                            _c("i", { staticClass: "feather icon-award" }),
                            _vm._v(
                              "  " +
                                _vm._s(_vm.__("event.cards.premium")) +
                                "\n                                "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between",
                },
                [
                  _c("span", { staticClass: "primary font-medium-3" }, [
                    _c("i", { staticClass: "feather icon-calendar" }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.event.event_start_end_date),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm.event.tickets.length > 0 &&
                  this.can_buy_tickets === true &&
                  this.sold_out !== true &&
                  this.price !== null
                    ? _c("div", { staticClass: "text-right" }, [
                        _c("span", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.__("globals.from")) +
                                " " +
                                _vm._s(
                                  _vm._f("currency")(this.price, _vm.site_tax)
                                )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-primary waves-effect waves-light",
                            attrs: {
                              href:
                                "/member/event/" + _vm.event.slug + "/tickets",
                            },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.__("event.form.buttons.buy_tickets")
                                ) +
                                " "
                            ),
                            _c("i", { staticClass: "fa fa-tag" }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { id: "single-normal" } }, [
                _c("div", { staticClass: "dropdown" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-sm btn-outline-success btn-default waves-effect waves-light mobile-hide dropdown-toggle",
                      attrs: {
                        type: "button",
                        id: "dropdownMenuButton",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                      },
                    },
                    [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.__("event.form.buttons.add_to_calendar")) +
                          "\n                                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu ml-05 pb-0",
                      attrs: { "aria-labelledby": "dropdownMenuButton" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "m-05 pb-05 text-center border-bottom" },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "inherit" },
                              attrs: { href: _vm.getGoogleCalendarLink },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-google text-danger",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                " " + _vm._s(_vm.__("event.form.links.gmail"))
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "m-05 pb-05 text-center border-bottom" },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "inherit" },
                              attrs: { href: _vm.getIcalCalendarLink },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-apple text-dark",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.__("event.form.links.icalendar"))
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-05 text-center " }, [
                        _c(
                          "a",
                          {
                            staticStyle: { color: "inherit" },
                            attrs: { href: _vm.getOutlookCalendarLink },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-calendar text-primary",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.__("event.form.links.outlook"))
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.event.event_summary != null
                ? _c("p", { staticClass: "pt-1" }, [
                    _c("span", {
                      staticClass: "breakAll",
                      attrs: { id: "tinymce" },
                      domProps: { innerHTML: _vm._s(_vm.event.event_summary) },
                    }),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row match-height" }, [
            _c("div", { staticClass: "col-12 col-md-8" }, [
              _c("h5", { staticClass: "border-bottom pb-05 mb-1" }, [
                _c("i", { staticClass: "feather icon-book-open" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.__("event.headers.admin.event_details")) +
                    "\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-start" }, [
                _c("p", [
                  _c("span", { staticClass: "user-name text-bold-600" }, [
                    _c("i", { staticClass: "fa fa-map-marker" }),
                    _vm._v(
                      " " + _vm._s(_vm.__("event.fields.text.location")) + ": "
                    ),
                  ]),
                  _c("br"),
                  _vm._v(
                    _vm._s(_vm.event.location) +
                      "\n                            "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "ml-1" }, [
                  _c("span", { staticClass: "user-name text-bold-600" }, [
                    _c("i", { staticClass: "fa fa-clock" }),
                    _vm._v(
                      " " + _vm._s(_vm.__("event.fields.text.venue")) + ": "
                    ),
                  ]),
                  _c("br"),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.event.venue) +
                      "\n                            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { staticClass: "user-name text-bold-600" }, [
                  _c("i", { staticClass: "fas fa-file-alt" }),
                  _vm._v(" " + _vm._s(_vm.__("globals.description")) + ": "),
                ]),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  staticClass: "breakAll image-resize",
                  attrs: { id: "tinymce" },
                  domProps: { innerHTML: _vm._s(_vm.event.event_description) },
                }),
              ]),
              _vm._v(" "),
              _vm.event.disabled === 1
                ? _c("div", { staticClass: "p-1" }, [
                    _c("div", { staticClass: "card bg-outline-gray" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _c("h4", { staticClass: "card-title danger" }, [
                          _vm._v(
                            "\n                                        " +
                              _vm._s(_vm.__("globals.event_inactive_title")) +
                              "\n                                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.__("globals.event_inactive_content")) +
                            "\n                                "
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("h5", { staticClass: "border-bottom pb-05 mb-1" }, [
                _c("i", { staticClass: "feather icon-user-plus" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.__("event.headers.admin.event_organiser")) +
                    "\n                        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { staticClass: "user-name text-bold-600" }, [
                  _c("i", { staticClass: "fa fa-building" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.__("event.fields.text.organisation_name")) +
                      ": "
                  ),
                ]),
                _c("br"),
                _vm._v(_vm._s(_vm.event.organisation_name)),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { staticClass: "user-name text-bold-600" }, [
                  _c("i", { staticClass: "fa fa-user" }),
                  _vm._v(" " + _vm._s(_vm.__("globals.name")) + ": "),
                ]),
                _c("br"),
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.event.contact_name) +
                    "\n                        "
                ),
              ]),
              _vm._v(" "),
              _vm.event.contact_phone
                ? _c("p", [
                    _c("span", { staticClass: "user-name text-bold-600" }, [
                      _c("i", { staticClass: "fa fa-phone" }),
                      _vm._v(" " + _vm._s(_vm.__("globals.phone")) + ": "),
                    ]),
                    _c("br"),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.event.contact_phone) +
                        "\n                        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.event.contact_email
                ? _c("p", [
                    _c("span", { staticClass: "user-name text-bold-600" }, [
                      _c("i", { staticClass: "fa fa-envelope" }),
                      _vm._v(" " + _vm._s(_vm.__("globals.email")) + ": "),
                    ]),
                    _c("br"),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.event.contact_email) +
                        "\n                        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "text-right mb-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-danger",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.report.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("event.form.buttons.report")))]
                ),
              ]),
              _vm._v(" "),
              _vm.event.group !== null
                ? _c("div", {}, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "/member/group/" + _vm.event.group.slug,
                        },
                      },
                      [
                        _c("div", { staticClass: "card text-white" }, [
                          _c("img", {
                            staticClass: "card-img img-fluid",
                            staticStyle: { height: "3rem" },
                            attrs: {
                              src:
                                _vm.event.group.group_cover == null
                                  ? "/images/cover.jpg"
                                  : _vm.event.group.group_cover.url,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "text-white mb-0",
                                  staticStyle: { "line-height": "1rem" },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.posted_in")) + " "
                                    ),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.event.group.title) + " "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-sm btn-outline-white ml-auto",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.__("event.form.buttons.view_group")
                                    ) + " "
                                  ),
                                  _c("i", {
                                    staticClass: "feather icon-chevron-right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.event.supplier !== null
                ? _c("div", {}, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/member/" +
                            _vm.event.supplier.type +
                            "/" +
                            _vm.event.supplier.slug,
                        },
                      },
                      [
                        _c("div", { staticClass: "card text-white" }, [
                          _c("img", {
                            staticClass: "card-img img-fluid",
                            staticStyle: { height: "3rem" },
                            attrs: {
                              src:
                                _vm.event.supplier.supplier_cover_image == null
                                  ? "/images/cover.jpg"
                                  : _vm.event.supplier.supplier_cover_image.url,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass: "text-white mb-0",
                                  staticStyle: { "line-height": "1rem" },
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.posted_to")) + " "
                                    ),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.event.supplier.title)
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-sm btn-outline-white ml-auto",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.__("globals.view_page")) + " "
                                  ),
                                  _c("i", {
                                    staticClass: "feather icon-chevron-right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.event.tickets.length > 0
            ? _c("div", [
                this.can_buy_tickets === true
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center pt-05 pb-05 border-top",
                      },
                      [
                        _c("div", { staticClass: "text-bold-700" }, [
                          this.price !== null
                            ? _c("span", [
                                _c("span", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.__("globals.from")) +
                                        " " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            this.price,
                                            _vm.site_tax
                                          )
                                        )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        this.sold_out !== true && this.price !== null
                          ? _c("div", { staticClass: "ml-auto" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-primary waves-effect waves-light",
                                  attrs: {
                                    href:
                                      "/member/event/" +
                                      _vm.event.slug +
                                      "/tickets",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.__("event.form.buttons.buy_tickets")
                                    ) + " "
                                  ),
                                  _c("i", { staticClass: "fa fa-tag" }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : this.can_buy_tickets === false &&
                    this.lowest_plan_name !== null &&
                    this.lowest_plan_price !== null
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center pt-05 pb-05 border-top",
                      },
                      [
                        _c("strong", [
                          _c("span", [
                            _c(
                              "a",
                              {
                                staticClass: "text-dark",
                                staticStyle: { "text-decoration": "underline" },
                                attrs: { href: "/member/plans" },
                              },
                              [_vm._v(_vm._s(_vm.__("globals.upgrade")))]
                            ),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.__("globals.to_get_it_for")) +
                                " " +
                                _vm._s(
                                  _vm._f("currency")(
                                    this.lowest_plan_price,
                                    _vm.site_tax
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.__("globals.on_a")) +
                                "\n                                " +
                                _vm._s(this.lowest_plan_name) +
                                " " +
                                _vm._s(_vm.__("globals.plan")) +
                                "\n                            "
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm.event.contact_link != null &&
              (_vm.event.event_privacy === 0 || _vm.event.event_privacy === 1)
            ? _c(
                "div",
                { staticClass: "d-flex align-items-center border-top" },
                [
                  _c("div", { staticClass: "ml-auto pt-1 pb-1 white" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-sm btn-primary waves-effect waves-light",
                        attrs: {
                          href: _vm.event.contact_link,
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.__("event.form.buttons.view_event_site")) +
                            " "
                        ),
                        _c("i", { staticClass: "feather icon-chevron-right" }),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex border-top justify-content-between" }, [
        _c(
          "div",
          { staticClass: "font-small-3 text-bold-700" },
          [
            _c("likes", {
              attrs: {
                id: this.event.slug,
                "likes-count": this.event.likesCount,
                "is-liked": this.event.isLiked,
                "liked-by-users": this.event.userLikes,
                type: "event",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "font-small-3 text-bold-700" }, [
          _c(
            "a",
            {
              staticClass: "p-05 d-block",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.commentsShow = !_vm.commentsShow
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-comment-o" }),
              _vm._v(" "),
              _vm.commentsCount === 1
                ? _c("span", [
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.commentsCount) },
                    }),
                    _vm._v(" " + _vm._s(_vm.__("globals.comment"))),
                  ])
                : _c("span", [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.commentsCount === 0 ? " " : _vm.commentsCount
                        ),
                      },
                    }),
                    _vm._v(" " + _vm._s(_vm.__("globals.comments"))),
                  ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "font-small-3 text-bold-700" },
          [
            _c("social-share", {
              attrs: { id: this.event.id, social: this.event.socialShare },
              on: { shareModal: _vm.triggerShareModal },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.commentsShow
      ? _c(
          "div",
          [
            _c("comments", {
              attrs: {
                newsfeed_uuid: this.event.newsfeed_uuid,
                id: this.event.slug,
                type: "event",
              },
              on: { length: _vm.updateCommentsCount },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.share_newsfeed
      ? _c(
          "div",
          [
            _c("share-modal", {
              attrs: {
                original_newsfeed_id: this.event.newsfeed_id,
                module: _vm.event,
                type: "event",
              },
              on: {
                closeModal: function ($event) {
                  _vm.share_newsfeed = false
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }